import React from 'react';
import { ApprovalChainStatus } from './_approval-chain-status';
import { Title, VerticalSteps } from '@common/components';
import { ApprovalChainType } from '@approvals/graphql/fragments';
import { ApprovableDescription } from '@approvals/components/approval-chain-decision-steps/_approvable-description';

type Props = {
  approvalChain: ApprovalChainType;
  displayActionButtonsInsideStep: boolean;
  displayTitle: boolean;
  extraApprovalButton?: React.ReactNode;
};

export const ApprovalChainDecisionSteps = ({
  approvalChain,
  displayActionButtonsInsideStep = false,
  displayTitle = false,
  extraApprovalButton,
}: Props) => {
  const message = computeMessage(
    approvalChain.satisfied,
    approvalChain.rejected
  );

  return (
    <>
      {displayTitle && (
        <div style={{ marginBottom: 24 }}>
          <Title weight="bold" size="h2">
            {message}
          </Title>
        </div>
      )}
      <VerticalSteps className="approval-chain-decision-steps__vertical-steps">
        <VerticalSteps.Step status="finish" hideIcon>
          <ApprovalChainStatus
            key={`${approvalChain.id}_content`}
            approvalChain={approvalChain}
            displayActionButtonsInsideStep={displayActionButtonsInsideStep}
            extraApprovalButton={extraApprovalButton}
          />
        </VerticalSteps.Step>
        <VerticalSteps.Step status="finish" hideIcon>
          <ApprovableDescription {...approvalChain} />
        </VerticalSteps.Step>
      </VerticalSteps>
      <style jsx>{`
        :global(.approval-chain-decision-steps__vertical-steps) {
          max-width: 640px;
        }
      `}</style>
    </>
  );
};

function computeMessage(satisfied: boolean, rejected: boolean) {
  if (satisfied) {
    return 'This Request was approved';
  }

  if (rejected) {
    return 'This Request was not approved';
  }

  return 'This Request is pending approval';
}
